import { render, staticRenderFns } from "./profile-label-group.vue?vue&type=template&id=c3e83cb8&scoped=true&"
import script from "./profile-label-group.vue?vue&type=script&lang=js&"
export * from "./profile-label-group.vue?vue&type=script&lang=js&"
import style0 from "./profile-label-group.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./profile-label-group.vue?vue&type=style&index=1&id=c3e83cb8&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e83cb8",
  null
  
)

export default component.exports